import React from 'react';
import '../App.css';
import logo from '../assets/logo.png';

const Doctors = () => {
  return (
    <div className="doctors-page">
      {/* Header */}
      <header>
      <nav className="navbar">
          <a href="/" className="logo">
            <img src={logo} alt="Chaman Hospital" className="logo-img" />
          </a>
          
          <ul className="nav-links">
            <li><a href="/">Home</a></li>
            <li><a href="/Appointment">Appointment</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/doctors" className="active">Doctors</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </nav>
      </header>

      {/* Doctors Section */}
      <section className="services-section">
        <div className="container">
          <h2>Our Expert Doctors</h2>
          <p>Meet the highly qualified medical professionals who are dedicated to providing exceptional healthcare to our patients.</p>

          <div className="services-list">
            <div className="service">
              <h3>Dr. Mandip Singh</h3>
              <p>MBBS, MD (Medicine) - Specialist in Internal Medicine with 10+ years of experience.</p>
            </div>
            <div className="service">
              <h3>Dr. Rajeev Malhotra</h3>
              <p>MS (General Surgery) - Expert in laparoscopic and open surgical procedures.</p>
            </div>
            <div className="service">
              <h3>Dr. Meenakshi Gupta</h3>
              <p>DCH, MD (Pediatrics) - Renowned child specialist ensuring best pediatric care.</p>
            </div>
            <div className="service">
              <h3>Dr. A.K. Verma</h3>
              <p>DM (Cardiology) - Experienced cardiologist for all heart-related conditions.</p>
            </div>
            <div className="service">
              <h3>Dr. Simran Kaur</h3>
              <p>MD (Gynecology) - Specialist in women’s health, maternity, and prenatal care.</p>
            </div>
            <div className="service">
              <h3>Dr. Ravi Singh</h3>
              <p>Physiotherapist - Skilled in rehabilitation and pain management therapies.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer>
        <div className="footer-content">
          <p>© {new Date().getFullYear()} Chaman Hospital. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Doctors;
